<template>
    <a-form 
    class="form-plus"
    ref="formRef" 
    :auto-label-width="option?.autoLabelWidth??defaultOption.autoLabelWidth"
    :layout="option?.layout??defaultOption.layout??'horizontal'"
    :scrollToFirstError="option?.scrollToFirstError??defaultOption.scrollToFirstError"
    :size="option?.size??defaultOption.size"
    :label-align="option?.labelAlign??defaultOption.labelAlign"
    :model="formData" 
    @submit="handleSubmit"
    :disabled="true" 
    >
      <a-row class='form-row__container'
             :justify="option?.justify??defaultOption.justify"
             :align="option?.align??defaultOption.align"
             :wrap="option?.wrap??defaultOption.wrap"
             :cols="24"
              ref="rowRef"
             :gutter="option?.gutter||defaultOption.gutter"
             :colGap="option?.colGap ?? defaultOption.colGap"
             :rowGap="option?.rowGap ?? defaultOption.rowGap">

        <template v-for="(item,index) in option?.columns"  ref="dragRef">
          <a-col 
          style="margin-top:0px;padding: 0;"
          v-if="item.display!==false&&item.hidden!==true" :span="item.span ?? option?.span ?? defaultOption.span" :offset="item.offset??0" :order="item.order??0">
            <a-form-item 
            :row-class="'form-plus-item'"
            :label-col-style="{
              color:'#333',
              fontSize:'16px',
              fontWeight:'500',
              width:'240px',
              maxWidth:'240px',
              fontFamily:'HarmonyOS_Sans'
            }"
             :[loading.submit?'':'disabled']="isDisabled(item.disabled)" 
             :label="item.label"
             :tooltip="item.tooltip"
             :help="item.help"
             :extra="item.extra"
             :label-component="item.labelComponent"
             :hide-label="item.hideLabel"
             :hide-asterisk="item.hideAsterisk??true"
              :label-col-flex="option?.labelWidth??defaultOption.labelWidth"
             :feedback="item.feedback"
             :content-flex="item.contentFlex"
             :field="item.bind??item.field" :rules="item.rules">
              <!-- label -->
              <template #label>
                <div
                      style="display: flex; align-items: center; justify-content: space-between; width: 100%;"
                    >
                      <span class="form-item-label" :data-field="item.field">{{ item.label }}</span>
                      <HelpButton
                        v-if="item?.helpIconText"
                        :content="item?.helpIconText"
                        :width="item?.helpIconWidth ?? 600"
                      />
                    </div>
              </template>

              <!-- help -->
              <template v-if="slots[item.field + 'Help']||item.help" #help>
                <slot v-if="slots[item.field + 'Help']" :name="item.field + 'Help'"></slot>
                <span v-else v-html="item.help"></span>
              </template>
              <!-- Extra 补充信息 -->
              <template v-if="slots[item.field + 'Extra']||item.extra" #extra>
                <slot v-if="slots[item.field + 'Extra']" :name="item.field + 'Extra'"></slot>
                <span v-else v-html="item.extra"></span>
              </template>
              <!-- columns 子项 -->
              <slot v-if="slots[item.field]" :name="item.field" :item="item" :size="option?.size??defaultOption.size"></slot>
              <component 
              v-else 
              v-bind="omit(item,['onChange','type'])"
                    :style="{ ...(item.type !== 'switch' ? { width: '100%' } : {}), ...item.style }"
                    :is="componentData[item.type] || componentData.select"
                    :size="option?.size ?? defaultOption.size"
                    :disabled="option?.detail ?? item.disabled ?? false"
                    :modelValue="getValue(item)"
                    @update:modelValue="updateValue(item, $event)"
                    v-model:visibility="item.visibility"
                    :dicData="dicData[item.field] || item.dicData"
                    :append="item.append"
                    v-model:form="formData"
                    :hide-button="true"
                    @change="(env) => onFormItemChange(env, item)"
                    @dicClicked="(dicItem) => onDicClick(dicItem, item)"

              ></component>
            </a-form-item>
          </a-col>
        </template>
     </a-row>
     <template v-for="group in option?.groups">
  <a-row
    :style="option?.groupContainerStyle ?? {}"
    class="form-row__container"
    :justify="option?.justify ?? defaultOption.justify"
    :align="option?.align ?? defaultOption.align"
    :wrap="option?.wrap ?? defaultOption.wrap"
    :cols="24"
    ref="rowRef"
    :gutter="option?.gutter || defaultOption.gutter"
    :colGap="option?.colGap ?? defaultOption.colGap"
    :rowGap="option?.rowGap ?? defaultOption.rowGap"
    v-if="group.display ?? true"
  >
    <!-- ✅ 这里用 a-col 包裹整个 Collapse -->
    <a-col :span="24">
      <Collapse
        :style="{ width: '100%' }"
        expand-icon-position="right"
        v-model:active-key="defaultCollapseKey"
        :bordered="false"
        @change="(key)=>handleCollapseChange(key,group.field,group.checkField)"
      >
        <CollapseItem :key="group.field" :header="group.label">
          <template #header>
            <div class="collapse-item-header">
            <span v-if="group.checkField" @click.stop>
              <checkboxItem @change="(checked)=>handleCheckboxChange(checked,group.field,group.checkField)"  style="transform: translateY(3px);" v-model="formData[group.checkField]"></checkboxItem>
            </span>
              {{ group.label }}
            </div>
          </template>

          <!-- 表单项 -->
          <a-row>
            <template v-for="item in group.columns">
              <a-col
                v-if="item.display!==false&&item.hidden!==true"
                :span="item.span ?? option?.span ?? defaultOption.span"
                :offset="item.offset ?? 0"
                :order="item.order ?? 100"
              >
                <a-form-item
                  :label-col-style="{
                    color: '#333',
                    fontSize: '16px',
                    fontWeight: '500',
                    fontFamily: 'HarmonyOS_Sans'
                  }"
                  :[loading.submit?'':'disabled']="isDisabled(item.disabled)"
                  :label="item.label"
                  :tooltip="item.tooltip"
                  :help="item.help"
                  :extra="item.extra"
                  :label-component="item.labelComponent"
                  :hide-label="item.hideLabel"
                  :hide-asterisk="item.hideAsterisk??true"
                  :content-flex="item.contentFlex"
                  :feedback="item.feedback"
                  :label-col-flex="option?.labelWidth ?? defaultOption.labelWidth"
                  :field="item.field"
                  :rules="item.rules"
                >
                  <!-- label -->
                  <template #label>
                    <div
                      style="display: flex; align-items: center; justify-content: space-between; width: 100%;"
                    >
                      <span class="form-item-label" :data-field="item.field">{{ item.label }}</span>
                      <HelpButton
                        v-if="item?.helpIconText"
                        :content="item?.helpIconText"
                        :width="item?.helpIconWidth ?? 600"
                      />
                    </div>
                  </template>

                  <!-- help -->
                  <template v-if="slots[item.field + 'Help'] || item.help" #help>
                    <slot v-if="slots[item.field + 'Help']" :name="item.field + 'Help'"></slot>
                    <span v-else v-html="item.help"></span>
                  </template>

                  <!-- extra -->
                  <template v-if="slots[item.field + 'Extra'] || item.extra" #extra>
                    <slot v-if="slots[item.field + 'Extra']" :name="item.field + 'Extra'"></slot>
                    <span v-else v-html="item.extra"></span>
                  </template>

                  <!-- 组件渲染 -->
                  <slot
                    v-if="slots[item.field]"
                    :name="item.field"
                    :item="item"
                    :size="option?.size ?? defaultOption.size"
                  ></slot>
                  <component
                    v-else
                    v-bind="omit(item,['onChange','type'])"
                    :style="{ ...(item.type !== 'switch' ? { width: '100%' } : {}), ...item.style }"
                    :is="componentData[item.type] || componentData.select"
                    :size="option?.size ?? defaultOption.size"
                    :minWidth="item.minWidth??group.minWidth??option.minWidth??defaultOption.minWidth"
                    :disabled="option?.detail ?? item.disabled ?? false"
                    :modelValue="getValue(item)"
                    @update:modelValue="updateValue(item, $event)"
                    v-model:visibility="item.visibility"
                    :dicData="dicData[item.field] || item.dicData"
                    :append="item.append"
                    v-model:form="formData"
                    :hide-button="true"
                    @change="(env) => onFormItemChange(env, item)"
                    @dicClicked="(dicItem) => onDicClick(dicItem, item)"
                  ></component>
                </a-form-item>
              </a-col>
            </template>
          </a-row>
        </CollapseItem>
      </Collapse>
    </a-col>
  </a-row>
</template>
      <!-- <a-row  :class='{formMenuContainer:option?.menu ?? !option?.detail ?? true}' v-if="!option?.search&&option?.detail!==true">
        <a-col :order="10000" :span="option?.menuSpan??24" v-if="option?.menu ?? !option?.detail ?? true" :style="{
          textAlign: option?.menuAlign ?? 'center',
        }">
          <slot v-if="slots.menu??false" name="menu" :size="option?.size??defaultOption.size" :loading="loading.submit"></slot>
          <a-space wrap style="margin-top: 10px;">
            <slot name="menuLeft" :size="option?.size??defaultOption.size" :loading="loading.submit"></slot>
            <slot name="suffix" :loading.submit="loading.submit">
              <a-button id="submit-button"  :size="option?.size??defaultOption.size" type="primary" :loading="loading.submit" v-if="option?.menuBtn ?? option?.submitBtn ?? true"
                html-type="submit">{{ option?.submitBtnText ?? defaultOption.submitBtnText}}</a-button>
              <a-button  :size="option?.size??defaultOption.size" v-if="option?.menuBtn ?? option?.resetBtn ?? true" @click="formReset()">{{  option?.resetBtnText ?? defaultOption.resetBtnText}}</a-button>
            </slot>
            <slot name="menuright" :size="option?.size??defaultOption.size" :loading="loading.submit"></slot>
          </a-space>
        </a-col>
      </a-row> -->
    </a-form>
</template>

<script  setup>
import ItemDimension from "./items/item-dimension.vue";
import ItemOrder from "./items/item-order.vue"; 
import {defaultFormOption} from "../config/default"
import { validataNull,omit,deepClone } from "../utils";
import {onMounted, reactive,ref,useAttrs,useSlots,computed,unref,provide,nextTick,toRaw   } from "vue"
import {Collapse,CollapseItem} from "@arco-design/web-vue"
import {InputNumber as aInputNumber} from "@arco-design/web-vue"
import{Form as aForm,FormItem as aFormItem,Input as aInput,Row as aRow,Col as aCol,Tooltip as aTooltip,Button as aButton,Space as aSpace,Textarea} from "@arco-design/web-vue"
import PcbRadio from "./pcb-radio.vue";
import PcbCheckbox from "./pcb-checkbox.vue";
import HelpButton from "./help-button.vue";
import ASelect from "./a-select.vue";
import PcbDiv from "./pcb-div.vue";
import PcbNumber from "./pcb-number.vue";
import PcbFormSelf from "./pcb-form-self.vue";
import checkboxItem from "./checkbox-item.vue";
const formData=defineModel({
    default:()=>({})
})
defineOptions({
  name:"pcb-form"
})
const propEvents={
  setColumn,
  getColumn,
  set,
  get,
  display
}
provide("events",propEvents)
const componentData={
    input:aInput,
    radio:PcbRadio,
    checkbox:PcbCheckbox,
    textarea:Textarea,
    select:ASelect,
    number:aInputNumber,
    div:PcbDiv,
    html:PcbDiv,
    numberPlus:PcbNumber,
    itemDimension:ItemDimension,
    itemOrder:ItemOrder,
    form:PcbFormSelf,

}
const formRef=ref()
const defaultOption = defaultFormOption
const props=defineProps({
  option:{
    type:Object,
    default:()=>({})
  },
  rules:{
    type:Array,
    default:()=>[]
  }
})
// 默认展开节点
const defaultCollapseKey=ref(props.option?.groups?.filter(item=>item.checkField===undefined&&item.firstDiaplay!==false).map(item=>item.field))
// 切换节点上的计价器 - checkbox 改变时，对应展开/收起 Collapse
function handleCheckboxChange(checked,field,checkField){
  if(checkField){
    nextTick(()=>{
      // 根据 checkbox 状态展开/收起对应的 Collapse
      // formData[checkField] 会通过 v-model 自动更新，不需要手动更新
      if(checked){
        // 如果 checkbox 选中，展开对应的 Collapse
        if(!defaultCollapseKey.value.includes(field)){
          defaultCollapseKey.value = [...defaultCollapseKey.value, field]
        }
      } else {
        // 如果 checkbox 未选中，收起对应的 Collapse
        defaultCollapseKey.value = defaultCollapseKey.value.filter(item => item !== field)
      }
    })
  }
}

// 展开事件 - Collapse 展开/收起时，更新 checkbox 状态
function handleCollapseChange(key,field,checkField){
  if(checkField){
    nextTick(()=>{
      // 根据 Collapse 的展开状态更新 checkbox
      const isExpanded = key.includes(field)
      formData.value[checkField] = isExpanded
    })
  }
}
const option=computed(()=>{
  return props.option
})
const emits = defineEmits(["submit", "reset","form-change"]);
const slots = useSlots()
const attrs=  useAttrs()
const dicData= reactive({});

// 添加标志防止规则循环调用
let isUpdatingRules = false;
// 记录规则更新的深度，防止无限嵌套
let ruleUpdateDepth = 0;
// 最大更新深度
const MAX_RULE_DEPTH = 3;
// 记录最近的字段更新，防止反复切换
const recentUpdates = new Map();


// 各种状态判断
onMounted(()=>{
  // 获取字典数据
  setInitValue()
  nextTick(()=>{
      setRules()
    })
})
  // 设置初始值
 function setInitValue() {
  if(props.option.columns){
    props.option.columns.forEach((item) => {
      if ((item.default||item.default===0)&&item.display!==false) {
        updateValue(item, item.default);
      }
    })
  }
  if(props.option.groups){
    props.option.groups.forEach((item) => {
      item.columns.forEach((item) => {
        if ((item.default||item.default===0)&&item.display!==false) {
          updateValue(item, item.default);
        }
      })
    })
  }
}
function isDisabled(disabled) {
  return props.option.disabled ?? disabled ?? false;
}

/************表单事件 event ********* */
const loading = reactive({
  submit: false,
  reset: false,
});
// 提交回调处理
function done() {
  loading.submit = false;
}
// 提交
const handleSubmit = ({ values, errors }) => {
  if (errors === undefined) {
    loading.submit = true;
    emits("submit", unref(values), done);
  }
};
// 重置表单
function formReset() {
  formRef.value.resetFields();
  formRef.value.clearValidate();
  emits("reset");
}
function onDicClick(dicItem,item){
  if(item.onDicClick){
    item.onDicClick(dicItem,toRaw(item),propEvents)
  }
}

function onFormItemChange(val,item){
  // 使用 nextTick 确保 formData 已经更新到最新值
  nextTick(() => {
    formRef.value?.innerValidateField(item.field)
    emits("form-change",val,item,done);
    if (item.onChange) {
      item.onChange(val,propEvents)
    }
  })
  
  // 清理过期的更新记录（超过1秒的记录）
  const now = Date.now()
  for (const [key, timestamp] of recentUpdates.entries()) {
    if (now - timestamp > 1000) {
      recentUpdates.delete(key)
    }
  }
  
  if (!isUpdatingRules) {
    nextTick(()=>{
      setRules()
    })
  }
}
function setRules(){
  if (ruleUpdateDepth >= MAX_RULE_DEPTH) {
    return
  }
  
  ruleUpdateDepth++
  
  const rulesEngine = props.rules
  if(rulesEngine&&Array.isArray(rulesEngine)){
    // 收集所有需要更新的字段和对应的新字典数据
    const pendingUpdates = []
    rulesEngine.forEach(ruleConfig=>{
      const { key, rules, show } = ruleConfig

      const targetColumn = getColumn(key)
      if (!targetColumn) {
        console.warn(`字段 ${key} 不存在，跳过规则处理`)
        return
      }

      if (targetColumn.display === false) {
        return
      }
      let ruleMatched = false
      let newDicData = null
      // 如果有条件规则，遍历查找匹配的规则
      if (rules && Array.isArray(rules) && rules.length > 0) {
        rules.forEach(rule => {
          if(ruleMatched) return 
          
          const isRuleMatched = rule.by.every(conditionObj => {
            return Object.keys(conditionObj).every(conditionField => {
              const conditionValues = conditionObj[conditionField]
              const currentFieldValue = formData.value[conditionField]
              
              if (currentFieldValue === undefined || currentFieldValue === null || currentFieldValue === '') {
                return false
              }
              
              return conditionValues.some(conditionValue => {
                if(conditionValue.includes(',')) {
                  const rangeValues = conditionValue.split(',')
                  return rangeValues.includes(String(currentFieldValue))
                }
                return String(conditionValue) === String(currentFieldValue)
              })
            })
          })          
          if(isRuleMatched) {
            newDicData = getShowDicData(key, rule.show, targetColumn.dicData)
            ruleMatched = true
          }
        })
      }
      
      // 如果没有规则匹配，使用外层的show作为默认值
      if(!ruleMatched && show) {
        if(show === 'all') {
          newDicData = getAllDicData(key, targetColumn.dicData)
        } else if(Array.isArray(show)) {
          newDicData = getShowDicData(key, show, targetColumn.dicData)
        }
      }
      
      // 如果有新的字典数据，加入待更新列表
      if(newDicData) {
        pendingUpdates.push({ key, newDicData, targetColumn })
      }
    })
    
    // 批量更新所有字段的字典数据
    pendingUpdates.forEach(({ key, newDicData, targetColumn }) => {
      if (!isDicDataChanged(targetColumn.dicData, newDicData)) {
        return 
      }
      setColumn(key, 'dicData', newDicData)
    })
    
    nextTick(() => {
      pendingUpdates.forEach(({ key, newDicData }) => {
        setFormByDicData(key, newDicData)
      })
      
      // 重置更新深度
      ruleUpdateDepth--
    })
  } else {
    ruleUpdateDepth--
  }
}

// 配置显示的字典
function getShowDicData(field, showList, originalDicData) {
  const dicData = originalDicData || []
  return dicData.map(item => {
    return {
      ...item,
      show: showList.includes(item.value)
    }
  })
}

// 获取所有字典选项（全部显示）
function getAllDicData(field, originalDicData) {
  const dicData = originalDicData || []
  return dicData.map(item => {
    return {
      ...item,
      show: true  // 所有选项都显示
    }
  })
}

// 根据字典数据设置表单值
function setFormByDicData(key, dicData) {
  // 检查字段是否被隐藏，如果隐藏则不进行赋值操作
  const targetColumn = getColumn(key)
  if (!targetColumn || targetColumn.display === false) {
    return // 字段被隐藏，跳过赋值
  }
  
  const currentValue = get(key)
  
  const availableOptions = dicData.filter(item => item.show)
  
  if(availableOptions.some(item => item.value === currentValue)) {
    return
  } else {
    const now = Date.now()
    const lastUpdate = recentUpdates.get(key)
    if (lastUpdate && (now - lastUpdate) < 100) {
      return
    }  
    recentUpdates.set(key, now)
    isUpdatingRules = true 
    let newValue = null
    if(availableOptions.length > 0) {
      newValue = selectBestOption(currentValue, availableOptions)
    }
    
    set(key, newValue)
    isUpdatingRules = false 
    
    // 值被更新后
    setTimeout(() => {
      if(!isUpdatingRules && ruleUpdateDepth < MAX_RULE_DEPTH) {
        setRules()
      }
    }, 50) // 增加延迟时间
  }
}

// 选择最佳选项的策略
function selectBestOption(currentValue, availableOptions) {
  // 如果只有一个选项
  if (availableOptions.length === 1) {
    return availableOptions[0].value
  }
  if (currentValue && !isNaN(currentValue)) {
    const currentNum = parseFloat(currentValue)
    let closestOption = availableOptions[0]
    let minDiff = Math.abs(parseFloat(closestOption.value) - currentNum)
    
    availableOptions.forEach(option => {
      const optionNum = parseFloat(option.value)
      if (!isNaN(optionNum)) {
        const diff = Math.abs(optionNum - currentNum)
        if (diff < minDiff) {
          minDiff = diff
          closestOption = option
        }
      }
    })
    
    return closestOption.value
  }
  
  // 默认返回第一个选项
  return availableOptions[0].value
}

// 字典是否发生变化
function isDicDataChanged(oldData, newData) {
  if (!oldData && !newData) return false
  if (!oldData || !newData) return true
  if (oldData.length !== newData.length) return true

  for (let i = 0; i < oldData.length; i++) {
    if (oldData[i].show !== newData[i].show) {
      return true
    }
  }
  
  return false
}
// 功能函数
function getValue(conf){
  if(!validataNull(conf.bind)){
    return getNestedValue(formData.value,conf.bind)
  }
  else{
    return Reflect.get(formData.value,conf.field)
  }
}
// 更新函数值
function updateValue(conf,val){
  if(!validataNull(conf.bind)){
    formData[conf.field]=val
    // conf.onChange&&conf.onChange(val,propEvents)
    setNestedValue(formData.value,conf.bind,val)
  }
  else{
    Reflect.set(formData.value,conf.field,val)
    // conf.onChange&&conf.onChange(val,propEvents)
  }
}



  // bind 多层级
  const getNestedValue = (obj, path) => {
      return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    };
  const setNestedValue = (obj, path, value) => {
      const keys = path.split('.');
      const lastKey = keys.pop();
      const target = keys.reduce((acc, key) => acc[key] = acc[key] || {}, obj);
      target[lastKey] = value;
};
// 设置formData
function set(key,val){
  Reflect.set(formData.value,key,val)
}
// 获取formData
function get(key){
  if(validataNull(key)){
    return deepClone(formData.value)
  }
  return Reflect.get(formData.value,key)
}
function display(field,val){
  if(typeof val === 'boolean'){
  const defaultVal=getColumn(field)?.default
    if(val){
      setColumn(field,"display",val)
      if(defaultVal!==undefined){
        set(field,defaultVal)
      }
    }
    else if(!val){
      // 设置标志防止规则引擎重新赋值
      isUpdatingRules = true
      setColumn(field,"display",val)
      delete formData.value[field]
      
      // 延迟重置标志，确保setRules执行时能看到隐藏状态
      nextTick(() => {
        isUpdatingRules = false
      })
    }
  }
}
  function setColumn(field, prop, val) {
    const { found, config } = getFieldConfig(field,unref(props.option));
    if (found) {
      Reflect.set(config, prop, val);
      if(prop==='display'&&val===false){
       delete formData.value[field]
      }
    } else {
      // throw new Error("字段不存在");
    }
  }
  function getColumn(field) {
    const { found, config } = getFieldConfig(field,unref(props.option));
    if (found) {
      return config;
    } else {
      return undefined
    }
  }
    function getFieldConfig(field, option) {
    // 检查参数有效性
    if (!option || !field) {
      return {
        found: false,
        config: null,
      };
    }

    // 查找 `columns` 中的配置
    if (option.columns && Array.isArray(option.columns)) {
      const columnConfig = option.columns.find((col) => col.field === field);
      if (columnConfig) {
        return {
          found: true,
          config: columnConfig,
        };
      }
    }

    // 查找 `groups` 中的配置
    if (option.groups && Array.isArray(option.groups)) {
      for (const group of option.groups) {
        if (group.columns && Array.isArray(group.columns)) {
          const groupColumnConfig = group.columns.find((col) => col.field === field);
          if (groupColumnConfig) {
            return {
              found: true,
              config: groupColumnConfig,
              group: group.label, // 可选：返回所属分组的标签
            };
          }
        }
      }
    }

    return {
      found: false,
      config: null,
    };
  }
  
  async function submit() {
    try {
      const errors = await formRef.value.innerValidate()

      return {
        errors,
        values: formData.value
      }
    } catch (error) {
      return {
        errors: error,
        values: formData.value
      }
    }
  }

  defineExpose({
    submit:submit,
  })
</script>

<style scoped>
:deep(.arco-input-append){
    background-color: #f5f5f5;
  }
:deep(.arco-collapse-item-header){
  padding: 0px 0px 0px 12px;
isolation: isolate;
background: #F0F0F0 !important;
border:none !important;
border-radius: 5px;
}
:deep(.arco-form-item-message){
  display: none !important;
}
:deep(.arco-form-item){
  margin-bottom: 0px !important;
}
:deep(.arco-form-item-label){
  font-family: 'HarmonyOS_Sans',Roboto,Tahoma,Arial,"Microsoft YaHei UI"!important;
  width: 100%;
  font-family: 'HarmonyOS_Sans' !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  color: #333333 !important;
  white-space: normal !important;  /* 允许换行 */
  word-wrap: break-word !important;  /* 长单词换行 */
  overflow-wrap: break-word !important;  /* 现代浏览器换行属性 */
}

:deep(.arco-collapse-item-header-right + .arco-collapse-item-content){
  padding-left: 0px !important;
}
.collapse-item-header{
font-family: 'HarmonyOS_Sans';
font-style: normal;
font-weight: 700;
font-size: 16px;
line-height: 38px;
color: #333333;
}
.arco-row{
  /* background-color: #fff; */
  padding:2px 5px;
  box-sizing: border-box;
  max-width: 100%;
  margin: 0px 0px;
  margin-left:0px !important;
  margin-right:0px !important;
}
.form-plus{
  font-family: 'HarmonyOS_Sans',Roboto,Tahoma,Arial,"Microsoft YaHei UI"!important;
  font-size: 14px;
}
.form-plus-label{
  font-family: 'HarmonyOS_Sans',Roboto,Tahoma,Arial,"Microsoft YaHei UI"!important;
  font-size: 13px;
  font-weight: 500;
  color: #333;
}
.form-plus-item{
  margin-bottom: 1px;
}
.left-bot{
  /* border: 1px solid #ccc; */
  padding:10px 10px 15px 0;
  font-weight: 600;
  color: #333;
  font-size: 16px;
  /* border-radius: 5px; */
  /* margin-bottom: 10px; */
}
.form-item-label{
  font-style: normal;
  font-weight: 400;
  color: #333333;
  white-space: normal;  /* 允许换行 */
  word-wrap: break-word;  /* 长单词换行 */
  overflow-wrap: break-word;  /* 现代浏览器换行属性 */
font-family: HarmonyOS_Sans, HarmonyOS_Sans;
font-weight: 400;
font-size: 14px;
color: #333333;
line-height: 15px;
text-align: left;
font-style: normal;
text-transform: none;
}
:deep(.arco-col){
  padding-top: 4px;
}

/* 文本超出处理样式 */
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.text-ellipsis-multiline {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;  /* 标准属性 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  max-height: 3em;
}

.text-wrap {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.text-break-all {
  word-break: break-all;
  white-space: normal;
}

.text-pre-wrap {
  white-space: pre-wrap;
}
:deep(.arco-input-size-small){
  font-size: 12px !important;
  color:#333 !important;
}
.arco-input-wrapper{
  height: 28px !important;
}
</style>
<style >

.pcb-error-input {
  -webkit-animation: pcb-glow 800ms ease-out infinite alternate;
          animation: pcb-glow 800ms ease-out infinite alternate;
}
@-webkit-keyframes pcb-glow {
0% {
    border-color: red;
    -webkit-box-shadow: 0 0 5px rgba(255, 0, 0, 0.5), inset 0 0 5px rgba(255, 0, 0, 0.3), 0 0 0 red;
            box-shadow: 0 0 5px rgba(255, 0, 0, 0.5), inset 0 0 5px rgba(255, 0, 0, 0.3), 0 0 0 red;
}
100% {
    border-color: #e6e5e5;
    -webkit-box-shadow: 0 0 20px rgba(255, 255, 255, 0.6), inset 0 0 10px rgba(255, 255, 255, 0.4), 0 0 0 #e6e5e5;
            box-shadow: 0 0 20px rgba(255, 255, 255, 0.6), inset 0 0 10px rgba(255, 255, 255, 0.4), 0 0 0 #e6e5e5;
}
}
@keyframes pcb-glow {
0% {
    border-color: red;
    -webkit-box-shadow: 0 0 5px rgba(255, 0, 0, 0.5), inset 0 0 5px rgba(255, 0, 0, 0.3), 0 0 0 red;
            box-shadow: 0 0 5px rgba(255, 0, 0, 0.5), inset 0 0 5px rgba(255, 0, 0, 0.3), 0 0 0 red;
}
100% {
    border-color: #e6e5e5;
    -webkit-box-shadow: 0 0 20px rgba(255, 255, 255, 0.6), inset 0 0 10px rgba(255, 255, 255, 0.4), 0 0 0 #e6e5e5;
            box-shadow: 0 0 20px rgba(255, 255, 255, 0.6), inset 0 0 10px rgba(255, 255, 255, 0.4), 0 0 0 #e6e5e5;
}
}
</style>